import type { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { SelfViewIcon } from 'assets/svg';
import { MenuIconButtonHorizontal } from 'features/menu/components';

interface SelfViewSettingsMenuButtonProps {
  onClick?: () => void;
  isEnabled: boolean;
  isDisabled: boolean;
}

export const SelfViewSettingsMenuButton: FC<
  SelfViewSettingsMenuButtonProps
> = ({ onClick, isEnabled, isDisabled }) => {
  const { t } = useTranslation();

  return (
    <MenuIconButtonHorizontal
      title={t('selfView')}
      icon={<SelfViewIcon />}
      inactiveIcon={<SelfViewIcon />}
      isDisabled={isDisabled}
      isChecked={isEnabled}
      onClickHandler={onClick}
      isCheckIconVisible={isEnabled}
    />
  );
};
